import React from 'react';

interface BagelIconProps {
  height?: number;
  width?: number;
  fill?: string;
  bagelFill?: string; // Color for the bagel icon itself
  backgroundFill?: string; // Color for the background circle
  [key: string]: any;
}

export const BagelIcon: React.FC<BagelIconProps> = ({
  height = 20,
  width = 20, // Make it square for better centering
  fill = "white", // Deprecated, use bagelFill instead
  bagelFill,
  backgroundFill = "#FF8700",
  ...rest
}) => {
  // Use bagelFill if provided, otherwise fall back to fill prop
  const iconFill = bagelFill || fill;
  
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      {...rest}
    >
      {/* Background circle */}
      <circle cx="10" cy="10" r="10" fill={backgroundFill} />
      {/* Bagel icon, scaled and centered */}
      <path
        fill={iconFill}
        fillRule="evenodd"
        d="M2.5 10a7.5 7.5 0 1 1 15 0 7.5 7.5 0 0 1-15 0Zm7.5-2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Zm2.525-2.41a.5.5 0 0 1 .69-.155A6 6 0 0 1 16.25 10a.5.5 0 0 1-1 0 5 5 0 0 0-2.32-4.22.5.5 0 0 1-.155-.69Zm-1.585-1.015a6 6 0 0 0-1.128-.071.5.5 0 1 0 .032 1c.314-.009.628.01.94.06a.5.5 0 0 0 .156-.989Z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export default BagelIcon;
